<template>
  <div class="error-page">Tela de erro</div>
</template>

<script>
export default {
  name: 'error-page',
};
</script>

<style lang="scss" scoped></style>
